import type { MiniHostApps } from 'mini-opx-config/lib/types/MiniHostApps';

export type MiniHostAppFlag = { default: boolean } & {
    [key in MiniHostApps]?: boolean;
};

export type MiniHostAppFeature =
    | 'default'
    | 'campaigns'
    | 'headerAuth'
    | 'nativeFeedback'
    | 'readOnlyReadingPane'
    | 'substrateSearch'
    | 'native'
    | 'ads'
    | 'loadCultureFromHost'
    | 'adsInFocussedInbox'
    | 'syncOwaUserConfigCache'
    | 'validateBootCache'
    | 'offlineSync'
    | 'multiAccount'
    | 'swipeRefresh'
    | 'zoom'
    | 'overrideShowAdPreferencesChecks'
    | 'subscribeForHostUpdates'
    | 'inboxShopping'
    | 'miniMeControl'
    | 'referFriendsAndFamily'
    | 'allowTenantBlocking'
    | 'hostCampaigns'
    | 'nativeDiagnostics'
    | 'vernacularCompose';

export const MINI_HOST_APP_FLAGS: Record<MiniHostAppFeature, MiniHostAppFlag> = {
    default: {
        default: true,
        native: true,
    },
    ads: {
        default: true,
        native: true,
    },
    campaigns: {
        default: true,
        native: false, // Disable for all native clients by default
        outlooklite: true, // Enable for this client by overriding default config of native
    },
    headerAuth: {
        default: false,
        native: true,
    },
    native: {
        default: false,
        native: true,
    },
    nativeFeedback: {
        default: false,
        native: true,
    },
    readOnlyReadingPane: {
        default: false,
        teams: true,
        androidteams: true,
        iosteams: true,
    },
    substrateSearch: {
        default: true,
        native: true,
    },
    loadCultureFromHost: {
        default: false,
        native: true,
    },
    adsInFocussedInbox: {
        default: true,
        native: false,
    },
    syncOwaUserConfigCache: {
        default: false,
        native: true,
    },
    validateBootCache: {
        default: false,
        outlooklite: true,
    },
    offlineSync: {
        default: false,
        outlooklite: true,
    },
    multiAccount: {
        default: false,
        outlooklite: true,
    },
    swipeRefresh: {
        default: false,
        outlooklite: true,
    },
    zoom: {
        default: false,
        outlooklite: true,
    },
    overrideShowAdPreferencesChecks: {
        default: false,
        androidoutlook: true,
        iosoutlook: true,
        outlooklite: false,
    },
    subscribeForHostUpdates: {
        default: false,
        outlooklite: true,
    },
    inboxShopping: {
        default: true,
        outlooklite: false,
    },
    allowTenantBlocking: {
        default: false,
        outlooklite: true,
    },
    miniMeControl: {
        default: true,
        outlooklite: false,
    },
    referFriendsAndFamily: {
        default: false,
        outlooklite: true,
    },
    hostCampaigns: {
        default: false,
        outlooklite: true,
    },
    nativeDiagnostics: {
        default: false,
        outlooklite: true,
    },
    vernacularCompose: {
        default: true,
        outlooklite: true,
    },
};
